//条件、6月1日以降に、発注日が含まれる。ステータスは、取消済以外
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { ORDER_CANCELLED } from "../../constants/orderStatus";

export const getOrdersFromFiscalYearStart = async (
  billing_user_id,
  placed_at
) => {
  // billing_user_idをNumber型に変換（Firestoreに数値で保存されているため型一致が必要）
  const numericBillingUserId = Number(billing_user_id);
  console.log("params", numericBillingUserId, placed_at);
  try {
    let list = [];
    const ordersRef = collection(db, "orders");

    // クエリを作成
    const q = query(
      ordersRef,
      where("placed_at", ">=", placed_at), // placed_atが指定した日時以降
      where("status", "!=", ORDER_CANCELLED), // statusが"取消済"以外
      where("billing_user_id", "==", numericBillingUserId) // billing_user_idが指定した番号
    );

    // クエリを実行し、データを取得
    const snapshots = await getDocs(q);

    snapshots.forEach((snapshot) => {
      const data = snapshot.data();
      list.push(data);
    });
    // カテゴリIDごとにquantityを集計する
    const categoryTotals = {};

    list.forEach((order) => {
      const { category_id, quantity } = order;
      // 旧データにquantityが文字列で入っていても数値として集計する
      const numericQuantity = Number(quantity);

      if (categoryTotals[category_id]) {
        categoryTotals[category_id] += numericQuantity; // 既にカテゴリがある場合、quantityを加算
      } else {
        categoryTotals[category_id] = numericQuantity; // 新しいカテゴリの場合、quantityを初期化
      }
    });

    // 結果をオブジェクトの配列に変換
    const result = Object.keys(categoryTotals).map((category_id) => ({
      category_id,
      quantity: categoryTotals[category_id],
    }));

    return result; // 集計結果を返す
  } catch (error) {
    console.error("Error fetching orders:", error);
    return []; // エラー時に空リストを返す
  }
};
export default getOrdersFromFiscalYearStart;
